<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="&Sigma;&epsilon;&iota;&rho;ά C6100">
     &Sigma;&epsilon;&iota;&rho;ά C6100
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_el" title="&Pi;&lambda;&eta;&rho;&omicron;&phi;&omicron;&rho;ί&epsilon;&sigmaf; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&eta;&nu; &alpha;&sigma;&phi;ά&lambda;&epsilon;&iota;&alpha;">
     &Pi;&lambda;&eta;&rho;&omicron;&phi;&omicron;&rho;ί&epsilon;&sigmaf; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&eta;&nu; &alpha;&sigma;&phi;ά&lambda;&epsilon;&iota;&alpha;
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href="safety.html#d0e23" title="&Epsilon;&nu;&delta;&epsilon;ί&xi;&epsilon;&iota;&sigmaf;">
      &Epsilon;&nu;&delta;&epsilon;ί&xi;&epsilon;&iota;&sigmaf;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_el" title="&Gamma;&nu;&omega;&rho;&iota;&mu;ί&alpha; &mu;&epsilon; &tau;&omicron;&nu; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
     &Gamma;&nu;&omega;&rho;&iota;&mu;ί&alpha; &mu;&epsilon; &tau;&omicron;&nu; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
    </a>
   </p>
   <div id="divd0e187">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_el" title="&Epsilon;ύ&rho;&epsilon;&sigma;&eta; &pi;&lambda;&eta;&rho;&omicron;&phi;&omicron;&rho;&iota;ώ&nu; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&omicron;&nu; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
      &Epsilon;ύ&rho;&epsilon;&sigma;&eta; &pi;&lambda;&eta;&rho;&omicron;&phi;&omicron;&rho;&iota;ώ&nu; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&omicron;&nu; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_el" title="&Epsilon;&pi;&iota;&lambda;&omicron;&gamma;ή &theta;έ&sigma;&eta;&sigmaf; &gamma;&iota;&alpha; &tau;&omicron;&nu; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
      &Epsilon;&pi;&iota;&lambda;&omicron;&gamma;ή &theta;έ&sigma;&eta;&sigmaf; &gamma;&iota;&alpha; &tau;&omicron;&nu; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-models-topic.html#configured-models_el" title="&Delta;&iota;&alpha;&mu;&omicron;&rho;&phi;ώ&sigma;&epsilon;&iota;&sigmaf; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
      &Delta;&iota;&alpha;&mu;&omicron;&rho;&phi;ώ&sigma;&epsilon;&iota;&sigmaf; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_el" title="&Sigma;ύ&nu;&delta;&epsilon;&sigma;&eta; &kappa;&alpha;&lambda;&omega;&delta;ί&omega;&nu;">
      &Sigma;ύ&nu;&delta;&epsilon;&sigma;&eta; &kappa;&alpha;&lambda;&omega;&delta;ί&omega;&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_el" title="&Chi;&rho;ή&sigma;&eta; &tau;&omicron;&upsilon; &pi;ί&nu;&alpha;&kappa;&alpha; &epsilon;&lambda;έ&gamma;&chi;&omicron;&upsilon;">
      &Chi;&rho;ή&sigma;&eta; &tau;&omicron;&upsilon; &pi;ί&nu;&alpha;&kappa;&alpha; &epsilon;&lambda;έ&gamma;&chi;&omicron;&upsilon;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-power-button-and-indicator-light-topic.html#understanding-status-power-button-and-indicator-light_el" title="&Kappa;&alpha;&tau;&alpha;&nu;ό&eta;&sigma;&eta; &tau;&eta;&sigmaf; &kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta;&sigmaf; &tau;&omicron;&upsilon; &kappa;&omicron;&upsilon;&mu;&pi;&iota;&omicron;ύ &lambda;&epsilon;&iota;&tau;&omicron;&upsilon;&rho;&gamma;ί&alpha;&sigmaf; &kappa;&alpha;&iota; &tau;&eta;&sigmaf; &epsilon;&nu;&delta;&epsilon;&iota;&kappa;&tau;&iota;&kappa;ή&sigmaf; &lambda;&upsilon;&chi;&nu;ί&alpha;&sigmaf;">
      &Kappa;&alpha;&tau;&alpha;&nu;ό&eta;&sigma;&eta; &tau;&eta;&sigmaf; &kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta;&sigmaf; &tau;&omicron;&upsilon; &kappa;&omicron;&upsilon;&mu;&pi;&iota;&omicron;ύ &lambda;&epsilon;&iota;&tau;&omicron;&upsilon;&rho;&gamma;ί&alpha;&sigmaf; &kappa;&alpha;&iota; &tau;&eta;&sigmaf; &epsilon;&nu;&delta;&epsilon;&iota;&kappa;&tau;&iota;&kappa;ή&sigmaf; &lambda;&upsilon;&chi;&nu;ί&alpha;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_el" title="&Chi;&rho;ή&sigma;&eta; &tau;&eta;&sigmaf; &alpha;&rho;&chi;&iota;&kappa;ή&sigmaf; &omicron;&theta;ό&nu;&eta;&sigmaf;">
      &Chi;&rho;ή&sigma;&eta; &tau;&eta;&sigmaf; &alpha;&rho;&chi;&iota;&kappa;ή&sigmaf; &omicron;&theta;ό&nu;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-map-sfp-topic.html#menus-map-sfp_el" title="&Sigma;&chi;&epsilon;&delta;&iota;ά&gamma;&rho;&alpha;&mu;&mu;&alpha; &mu;&epsilon;&nu;&omicron;ύ">
      &Sigma;&chi;&epsilon;&delta;&iota;ά&gamma;&rho;&alpha;&mu;&mu;&alpha; &mu;&epsilon;&nu;&omicron;ύ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_el" title="&Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &mu;&iota;&alpha;&sigmaf; &sigma;&epsilon;&lambda;ί&delta;&alpha;&sigmaf; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu; &mu;&epsilon;&nu;&omicron;ύ">
      &Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &mu;&iota;&alpha;&sigmaf; &sigma;&epsilon;&lambda;ί&delta;&alpha;&sigmaf; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu; &mu;&epsilon;&nu;&omicron;ύ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_el" title="&Mu;&eta; &alpha;&pi;&omicron;&delta;&epsilon;&kappa;&tau;ό &chi;&alpha;&rho;&tau;ί">
      &Mu;&eta; &alpha;&pi;&omicron;&delta;&epsilon;&kappa;&tau;ό &chi;&alpha;&rho;&tau;ί
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_el" title="&Chi;&rho;ή&sigma;&eta; &alpha;&nu;&alpha;&kappa;&upsilon;&kappa;&lambda;&omega;&mu;έ&nu;&omicron;&upsilon; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ">
      &Chi;&rho;ή&sigma;&eta; &alpha;&nu;&alpha;&kappa;&upsilon;&kappa;&lambda;&omega;&mu;έ&nu;&omicron;&upsilon; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_el" title="&Rho;ύ&theta;&mu;&iota;&sigma;&eta; &kappa;&alpha;&iota; &chi;&rho;ή&sigma;&eta; &tau;&omega;&nu; &epsilon;&phi;&alpha;&rho;&mu;&omicron;&gamma;ώ&nu; &tau;&eta;&sigmaf; &alpha;&rho;&chi;&iota;&kappa;ή&sigmaf; &omicron;&theta;ό&nu;&eta;&sigmaf;">
     &Rho;ύ&theta;&mu;&iota;&sigma;&eta; &kappa;&alpha;&iota; &chi;&rho;ή&sigma;&eta; &tau;&omega;&nu; &epsilon;&phi;&alpha;&rho;&mu;&omicron;&gamma;ώ&nu; &tau;&eta;&sigmaf; &alpha;&rho;&chi;&iota;&kappa;ή&sigmaf; &omicron;&theta;ό&nu;&eta;&sigmaf;
    </a>
   </p>
   <div id="divd0e1161">
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_el" title="&Pi;&rho;&omicron;&sigma;&alpha;&rho;&mu;&omicron;&gamma;ή &tau;&eta;&sigmaf; &alpha;&rho;&chi;&iota;&kappa;ή&sigmaf; &omicron;&theta;ό&nu;&eta;&sigmaf;">
      &Pi;&rho;&omicron;&sigma;&alpha;&rho;&mu;&omicron;&gamma;ή &tau;&eta;&sigmaf; &alpha;&rho;&chi;&iota;&kappa;ή&sigmaf; &omicron;&theta;ό&nu;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_el" title="&Chi;&rho;ή&sigma;&eta; &tau;&eta;&sigmaf; &pi;&rho;&omicron;&sigma;&alpha;&rho;&mu;&omicron;&gamma;ή&sigmaf; &omicron;&theta;ό&nu;&eta;&sigmaf;">
      &Chi;&rho;ή&sigma;&eta; &tau;&eta;&sigmaf; &pi;&rho;&omicron;&sigma;&alpha;&rho;&mu;&omicron;&gamma;ή&sigmaf; &omicron;&theta;ό&nu;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-forms-and-favorites-topic.html#setting-up-forms-and-favorites_el" title="&Rho;ύ&theta;&mu;&iota;&sigma;&eta; &tau;&eta;&sigmaf; &epsilon;&phi;&alpha;&rho;&mu;&omicron;&gamma;ή&sigmaf; Forms and Favorites">
      &Rho;ύ&theta;&mu;&iota;&sigma;&eta; &tau;&eta;&sigmaf; &epsilon;&phi;&alpha;&rho;&mu;&omicron;&gamma;ή&sigmaf; Forms and Favorites
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_el" title="&Delta;&iota;&alpha;&mu;ό&rho;&phi;&omega;&sigma;&eta; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu; &tau;&eta;&sigmaf; &lambda;&epsilon;&iota;&tau;&omicron;&upsilon;&rho;&gamma;ί&alpha;&sigmaf; Eco">
      &Delta;&iota;&alpha;&mu;ό&rho;&phi;&omega;&sigma;&eta; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu; &tau;&eta;&sigmaf; &lambda;&epsilon;&iota;&tau;&omicron;&upsilon;&rho;&gamma;ί&alpha;&sigmaf; Eco
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_el" title="&Chi;&rho;ή&sigma;&eta; &tau;&eta;&sigmaf; &upsilon;&pi;&omicron;&sigma;&tau;ή&rho;&iota;&xi;&eta;&sigmaf; &pi;&epsilon;&lambda;&alpha;&tau;ώ&nu;">
      &Chi;&rho;ή&sigma;&eta; &tau;&eta;&sigmaf; &upsilon;&pi;&omicron;&sigma;&tau;ή&rho;&iota;&xi;&eta;&sigmaf; &pi;&epsilon;&lambda;&alpha;&tau;ώ&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_el" title="&Chi;&rho;ή&sigma;&eta; &tau;&eta;&sigmaf; &Delta;&eta;&mu;&iota;&omicron;&upsilon;&rho;&gamma;ί&alpha;&sigmaf; &kappa;&omega;&delta;&iota;&kappa;ώ&nu; QR">
      &Chi;&rho;ή&sigma;&eta; &tau;&eta;&sigmaf; &Delta;&eta;&mu;&iota;&omicron;&upsilon;&rho;&gamma;ί&alpha;&sigmaf; &kappa;&omega;&delta;&iota;&kappa;ώ&nu; QR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_el" title="&Rho;ύ&theta;&mu;&iota;&sigma;&eta; &tau;&omega;&nu; &omicron;&rho;ί&omega;&nu; &chi;&rho;ή&sigma;&eta;&sigmaf; &sigma;&upsilon;&sigma;&kappa;&epsilon;&upsilon;ή&sigmaf;">
      &Rho;ύ&theta;&mu;&iota;&sigma;&eta; &tau;&omega;&nu; &omicron;&rho;ί&omega;&nu; &chi;&rho;ή&sigma;&eta;&sigmaf; &sigma;&upsilon;&sigma;&kappa;&epsilon;&upsilon;ή&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-google-drive-topic.html#using-google-drive_el" title="&Chi;&rho;ή&sigma;&eta; &tau;&omicron;&upsilon; Google Drive">
      &Chi;&rho;ή&sigma;&eta; &tau;&omicron;&upsilon; Google Drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1389" title="&Delta;&iota;&alpha;&chi;&epsilon;ί&rho;&iota;&sigma;&eta; &epsilon;&pi;&alpha;&phi;ώ&nu;">
      &Delta;&iota;&alpha;&chi;&epsilon;ί&rho;&iota;&sigma;&eta; &epsilon;&pi;&alpha;&phi;ώ&nu;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_el" title="&Epsilon;&gamma;&kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta; &kappa;&alpha;&iota; &chi;&rho;ή&sigma;&eta; &tau;&omega;&nu; &chi;&alpha;&rho;&alpha;&kappa;&tau;&eta;&rho;&iota;&sigma;&tau;&iota;&kappa;ώ&nu; &pi;&rho;&omicron;&sigma;&beta;&alpha;&sigma;&iota;&mu;ό&tau;&eta;&tau;&alpha;&sigmaf;">
     &Epsilon;&gamma;&kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta; &kappa;&alpha;&iota; &chi;&rho;ή&sigma;&eta; &tau;&omega;&nu; &chi;&alpha;&rho;&alpha;&kappa;&tau;&eta;&rho;&iota;&sigma;&tau;&iota;&kappa;ώ&nu; &pi;&rho;&omicron;&sigma;&beta;&alpha;&sigma;&iota;&mu;ό&tau;&eta;&tau;&alpha;&sigmaf;
    </a>
   </p>
   <div id="divd0e1508">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_el" title="&Epsilon;&nu;&epsilon;&rho;&gamma;&omicron;&pi;&omicron;ί&eta;&sigma;&eta; &tau;&eta;&sigmaf; &lambda;&epsilon;&iota;&tau;&omicron;&upsilon;&rho;&gamma;ί&alpha;&sigmaf; &mu;&epsilon;&gamma;έ&theta;&upsilon;&nu;&sigma;&eta;&sigmaf;">
      &Epsilon;&nu;&epsilon;&rho;&gamma;&omicron;&pi;&omicron;ί&eta;&sigma;&eta; &tau;&eta;&sigmaf; &lambda;&epsilon;&iota;&tau;&omicron;&upsilon;&rho;&gamma;ί&alpha;&sigmaf; &mu;&epsilon;&gamma;έ&theta;&upsilon;&nu;&sigma;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_el" title="&Epsilon;&nu;&epsilon;&rho;&gamma;&omicron;&pi;&omicron;ί&eta;&sigma;&eta; &Phi;&omega;&nu;&eta;&tau;&iota;&kappa;ή&sigmaf; &kappa;&alpha;&theta;&omicron;&delta;ή&gamma;&eta;&sigma;&eta;&sigmaf;">
      &Epsilon;&nu;&epsilon;&rho;&gamma;&omicron;&pi;&omicron;ί&eta;&sigma;&eta; &Phi;&omega;&nu;&eta;&tau;&iota;&kappa;ή&sigmaf; &kappa;&alpha;&theta;&omicron;&delta;ή&gamma;&eta;&sigma;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_el" title="&Pi;&rho;&omicron;&sigma;&alpha;&rho;&mu;&omicron;&gamma;ή &tau;&omicron;&upsilon; &rho;&upsilon;&theta;&mu;&omicron;ύ &omicron;&mu;&iota;&lambda;ί&alpha;&sigmaf; &tau;&eta;&sigmaf; &Phi;&omega;&nu;&eta;&tau;&iota;&kappa;ή&sigmaf; &kappa;&alpha;&theta;&omicron;&delta;ή&gamma;&eta;&sigma;&eta;&sigmaf;">
      &Pi;&rho;&omicron;&sigma;&alpha;&rho;&mu;&omicron;&gamma;ή &tau;&omicron;&upsilon; &rho;&upsilon;&theta;&mu;&omicron;ύ &omicron;&mu;&iota;&lambda;ί&alpha;&sigmaf; &tau;&eta;&sigmaf; &Phi;&omega;&nu;&eta;&tau;&iota;&kappa;ή&sigmaf; &kappa;&alpha;&theta;&omicron;&delta;ή&gamma;&eta;&sigma;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_el" title="&Epsilon;&nu;&epsilon;&rho;&gamma;&omicron;&pi;&omicron;ί&eta;&sigma;&eta; &pi;&rho;&omicron;&phi;&omicron;&rho;&iota;&kappa;ώ&nu; &kappa;&omega;&delta;&iota;&kappa;ώ&nu; &pi;&rho;ό&sigma;&beta;&alpha;&sigma;&eta;&sigmaf; ή &pi;&rho;&omicron;&sigma;&omega;&pi;&iota;&kappa;ώ&nu; &alpha;&rho;&iota;&theta;&mu;ώ&nu; &alpha;&nu;&alpha;&gamma;&nu;ώ&rho;&iota;&sigma;&eta;&sigmaf;">
      &Epsilon;&nu;&epsilon;&rho;&gamma;&omicron;&pi;&omicron;ί&eta;&sigma;&eta; &pi;&rho;&omicron;&phi;&omicron;&rho;&iota;&kappa;ώ&nu; &kappa;&omega;&delta;&iota;&kappa;ώ&nu; &pi;&rho;ό&sigma;&beta;&alpha;&sigma;&eta;&sigmaf; ή &pi;&rho;&omicron;&sigma;&omega;&pi;&iota;&kappa;ώ&nu; &alpha;&rho;&iota;&theta;&mu;ώ&nu; &alpha;&nu;&alpha;&gamma;&nu;ώ&rho;&iota;&sigma;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_el" title="&Pi;&epsilon;&rho;&iota;ή&gamma;&eta;&sigma;&eta; &sigma;&tau;&eta;&nu; &omicron;&theta;ό&nu;&eta; &mu;&epsilon; &chi;&epsilon;&iota;&rho;&omicron;&nu;&omicron;&mu;ί&epsilon;&sigmaf;">
      &Pi;&epsilon;&rho;&iota;ή&gamma;&eta;&sigma;&eta; &sigma;&tau;&eta;&nu; &omicron;&theta;ό&nu;&eta; &mu;&epsilon; &chi;&epsilon;&iota;&rho;&omicron;&nu;&omicron;&mu;ί&epsilon;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_el" title="&Chi;&rho;ή&sigma;&eta; &tau;&omicron;&upsilon; &pi;&lambda;&eta;&kappa;&tau;&rho;&omicron;&lambda;&omicron;&gamma;ί&omicron;&upsilon; &sigma;&tau;&eta;&nu; &omicron;&theta;ό&nu;&eta;">
      &Chi;&rho;ή&sigma;&eta; &tau;&omicron;&upsilon; &pi;&lambda;&eta;&kappa;&tau;&rho;&omicron;&lambda;&omicron;&gamma;ί&omicron;&upsilon; &sigma;&tau;&eta;&nu; &omicron;&theta;ό&nu;&eta;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_el" title="&Tau;&omicron;&pi;&omicron;&theta;έ&tau;&eta;&sigma;&eta; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &kappa;&alpha;&iota; &epsilon;&iota;&delta;&iota;&kappa;ώ&nu; &mu;έ&sigma;&omega;&nu; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;">
     &Tau;&omicron;&pi;&omicron;&theta;έ&tau;&eta;&sigma;&eta; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &kappa;&alpha;&iota; &epsilon;&iota;&delta;&iota;&kappa;ώ&nu; &mu;έ&sigma;&omega;&nu; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;
    </a>
   </p>
   <div id="divd0e1711">
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#setting-paper-size-type_el" title="&Rho;ύ&theta;&mu;&iota;&sigma;&eta; &tau;&omicron;&upsilon; &mu;&epsilon;&gamma;έ&theta;&omicron;&upsilon;&sigmaf; &kappa;&alpha;&iota; &tau;&omicron;&upsilon; &tau;ύ&pi;&omicron;&upsilon; &tau;&omega;&nu; &epsilon;&iota;&delta;&iota;&kappa;ώ&nu; &mu;έ&sigma;&omega;&nu; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;">
      &Rho;ύ&theta;&mu;&iota;&sigma;&eta; &tau;&omicron;&upsilon; &mu;&epsilon;&gamma;έ&theta;&omicron;&upsilon;&sigmaf; &kappa;&alpha;&iota; &tau;&omicron;&upsilon; &tau;ύ&pi;&omicron;&upsilon; &tau;&omega;&nu; &epsilon;&iota;&delta;&iota;&kappa;ώ&nu; &mu;έ&sigma;&omega;&nu; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_el" title="&Delta;&iota;&alpha;&mu;ό&rho;&phi;&omega;&sigma;&eta; &tau;&omega;&nu; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu; &gamma;&iota;&alpha; &chi;&alpha;&rho;&tau;ί Universal">
      &Delta;&iota;&alpha;&mu;ό&rho;&phi;&omega;&sigma;&eta; &tau;&omega;&nu; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu; &gamma;&iota;&alpha; &chi;&alpha;&rho;&tau;ί Universal
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_el" title="&Tau;&omicron;&pi;&omicron;&theta;έ&tau;&eta;&sigma;&eta; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&iota;&sigmaf; &theta;ή&kappa;&epsilon;&sigmaf;">
      &Tau;&omicron;&pi;&omicron;&theta;έ&tau;&eta;&sigma;&eta; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&iota;&sigmaf; &theta;ή&kappa;&epsilon;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_el" title="&Tau;&omicron;&pi;&omicron;&theta;έ&tau;&eta;&sigma;&eta; &mu;έ&sigma;&omega;&nu; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf; &sigma;&tau;&omicron;&nu; &tau;&rho;&omicron;&phi;&omicron;&delta;ό&tau;&eta; &delta;&iota;&alpha;&phi;&omicron;&rho;&epsilon;&tau;&iota;&kappa;ώ&nu; &mu;&epsilon;&gamma;&epsilon;&theta;ώ&nu;">
      &Tau;&omicron;&pi;&omicron;&theta;έ&tau;&eta;&sigma;&eta; &mu;έ&sigma;&omega;&nu; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf; &sigma;&tau;&omicron;&nu; &tau;&rho;&omicron;&phi;&omicron;&delta;ό&tau;&eta; &delta;&iota;&alpha;&phi;&omicron;&rho;&epsilon;&tau;&iota;&kappa;ώ&nu; &mu;&epsilon;&gamma;&epsilon;&theta;ώ&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_el" title="&Sigma;ύ&nu;&delta;&epsilon;&sigma;&eta; &theta;&eta;&kappa;ώ&nu;">
      &Sigma;ύ&nu;&delta;&epsilon;&sigma;&eta; &theta;&eta;&kappa;ώ&nu;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_el" title="&Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;">
     &Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;
    </a>
   </p>
   <div id="divd0e1897">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_el" title="&Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &alpha;&pi;ό &upsilon;&pi;&omicron;&lambda;&omicron;&gamma;&iota;&sigma;&tau;ή">
      &Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &alpha;&pi;ό &upsilon;&pi;&omicron;&lambda;&omicron;&gamma;&iota;&sigma;&tau;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-forms-topic.html#printing-forms_el" title="&Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &phi;&omicron;&rho;&mu;ώ&nu;">
      &Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &phi;&omicron;&rho;&mu;ώ&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1948" title="&Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &alpha;&pi;ό &kappa;&iota;&nu;&eta;&tau;ή &sigma;&upsilon;&sigma;&kappa;&epsilon;&upsilon;ή">
      &Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &alpha;&pi;ό &kappa;&iota;&nu;&eta;&tau;ή &sigma;&upsilon;&sigma;&kappa;&epsilon;&upsilon;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-h2-topic.html#printing-from-flash-drive-h2_el" title="&Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &alpha;&pi;ό &mu;&omicron;&nu;ά&delta;&alpha; flash">
      &Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &alpha;&pi;ό &mu;&omicron;&nu;ά&delta;&alpha; flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_el" title="&Upsilon;&pi;&omicron;&sigma;&tau;&eta;&rho;&iota;&zeta;ό&mu;&epsilon;&nu;&epsilon;&sigmaf; &mu;&omicron;&nu;ά&delta;&epsilon;&sigmaf; flash &kappa;&alpha;&iota; &tau;ύ&pi;&omicron;&iota; &alpha;&rho;&chi;&epsilon;ί&omega;&nu;">
      &Upsilon;&pi;&omicron;&sigma;&tau;&eta;&rho;&iota;&zeta;ό&mu;&epsilon;&nu;&epsilon;&sigmaf; &mu;&omicron;&nu;ά&delta;&epsilon;&sigmaf; flash &kappa;&alpha;&iota; &tau;ύ&pi;&omicron;&iota; &alpha;&rho;&chi;&epsilon;ί&omega;&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_el" title="&Delta;&iota;&alpha;&mu;ό&rho;&phi;&omega;&sigma;&eta; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu; &gamma;&iota;&alpha; &epsilon;&mu;&pi;&iota;&sigma;&tau;&epsilon;&upsilon;&tau;&iota;&kappa;έ&sigmaf; &epsilon;&rho;&gamma;&alpha;&sigma;ί&epsilon;&sigmaf;">
      &Delta;&iota;&alpha;&mu;ό&rho;&phi;&omega;&sigma;&eta; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu; &gamma;&iota;&alpha; &epsilon;&mu;&pi;&iota;&sigma;&tau;&epsilon;&upsilon;&tau;&iota;&kappa;έ&sigmaf; &epsilon;&rho;&gamma;&alpha;&sigma;ί&epsilon;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-h-topic.html#printing-confidential-and-other-held-jobs-h_el" title="&Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &epsilon;&rho;&gamma;&alpha;&sigma;&iota;ώ&nu; &sigma;&epsilon; &alpha;&nu;&alpha;&mu;&omicron;&nu;ή">
      &Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &epsilon;&rho;&gamma;&alpha;&sigma;&iota;ώ&nu; &sigma;&epsilon; &alpha;&nu;&alpha;&mu;&omicron;&nu;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_el" title="&Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &lambda;ί&sigma;&tau;&alpha;&sigmaf; &delta;&epsilon;&iota;&gamma;&mu;ά&tau;&omega;&nu; &gamma;&rho;&alpha;&mu;&mu;&alpha;&tau;&omicron;&sigma;&epsilon;&iota;&rho;ώ&nu;">
      &Epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta; &lambda;ί&sigma;&tau;&alpha;&sigmaf; &delta;&epsilon;&iota;&gamma;&mu;ά&tau;&omega;&nu; &gamma;&rho;&alpha;&mu;&mu;&alpha;&tau;&omicron;&sigma;&epsilon;&iota;&rho;ώ&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_el" title="&Alpha;&kappa;ύ&rho;&omega;&sigma;&eta; &epsilon;&rho;&gamma;&alpha;&sigma;ί&alpha;&sigmaf; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;">
      &Alpha;&kappa;ύ&rho;&omega;&sigma;&eta; &epsilon;&rho;&gamma;&alpha;&sigma;ί&alpha;&sigmaf; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_el" title="&Alpha;&sigma;&phi;ά&lambda;&epsilon;&iota;&alpha; &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
     &Alpha;&sigma;&phi;ά&lambda;&epsilon;&iota;&alpha; &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
    </a>
   </p>
   <div id="divd0e2338">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_el" title="&Epsilon;&nu;&tau;&omicron;&pi;&iota;&sigma;&mu;ό&sigmaf; &tau;&eta;&sigmaf; &upsilon;&pi;&omicron;&delta;&omicron;&chi;ή&sigmaf; &alpha;&sigma;&phi;&alpha;&lambda;&epsilon;ί&alpha;&sigmaf;">
      &Epsilon;&nu;&tau;&omicron;&pi;&iota;&sigma;&mu;ό&sigmaf; &tau;&eta;&sigmaf; &upsilon;&pi;&omicron;&delta;&omicron;&chi;ή&sigmaf; &alpha;&sigma;&phi;&alpha;&lambda;&epsilon;ί&alpha;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_el" title="&Delta;&iota;&alpha;&gamma;&rho;&alpha;&phi;ή &mu;&nu;ή&mu;&eta;&sigmaf; &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
      &Delta;&iota;&alpha;&gamma;&rho;&alpha;&phi;ή &mu;&nu;ή&mu;&eta;&sigmaf; &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_el" title="&Delta;&iota;&alpha;&gamma;&rho;&alpha;&phi;ή &mu;&nu;ή&mu;&eta;&sigmaf; &sigma;&kappa;&lambda;&eta;&rho;&omicron;ύ &delta;ί&sigma;&kappa;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
      &Delta;&iota;&alpha;&gamma;&rho;&alpha;&phi;ή &mu;&nu;ή&mu;&eta;&sigmaf; &sigma;&kappa;&lambda;&eta;&rho;&omicron;ύ &delta;ί&sigma;&kappa;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption_el" title="&Delta;&iota;&alpha;&mu;ό&rho;&phi;&omega;&sigma;&eta; &kappa;&rho;&upsilon;&pi;&tau;&omicron;&gamma;&rho;ά&phi;&eta;&sigma;&eta;&sigmaf; &sigma;&kappa;&lambda;&eta;&rho;&omicron;ύ &delta;ί&sigma;&kappa;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
      &Delta;&iota;&alpha;&mu;ό&rho;&phi;&omega;&sigma;&eta; &kappa;&rho;&upsilon;&pi;&tau;&omicron;&gamma;&rho;ά&phi;&eta;&sigma;&eta;&sigmaf; &sigma;&kappa;&lambda;&eta;&rho;&omicron;ύ &delta;ί&sigma;&kappa;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_el" title="&Epsilon;&pi;&alpha;&nu;&alpha;&phi;&omicron;&rho;ά &pi;&rho;&omicron;&epsilon;&pi;&iota;&lambda;&epsilon;&gamma;&mu;έ&nu;&omega;&nu; &epsilon;&rho;&gamma;&omicron;&sigma;&tau;&alpha;&sigma;&iota;&alpha;&kappa;ώ&nu; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu;">
      &Epsilon;&pi;&alpha;&nu;&alpha;&phi;&omicron;&rho;ά &pi;&rho;&omicron;&epsilon;&pi;&iota;&lambda;&epsilon;&gamma;&mu;έ&nu;&omega;&nu; &epsilon;&rho;&gamma;&omicron;&sigma;&tau;&alpha;&sigma;&iota;&alpha;&kappa;ώ&nu; &rho;&upsilon;&theta;&mu;ί&sigma;&epsilon;&omega;&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_el" title="&Delta;ή&lambda;&omega;&sigma;&eta; &mu;&epsilon;&tau;&alpha;&beta;&lambda;&eta;&tau;ό&tau;&eta;&tau;&alpha;&sigmaf;">
      &Delta;ή&lambda;&omega;&sigma;&eta; &mu;&epsilon;&tau;&alpha;&beta;&lambda;&eta;&tau;ό&tau;&eta;&tau;&alpha;&sigmaf;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_el" title="&Sigma;&upsilon;&nu;&tau;ή&rho;&eta;&sigma;&eta; &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
     &Sigma;&upsilon;&nu;&tau;ή&rho;&eta;&sigma;&eta; &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
    </a>
   </p>
   <div id="divd0e2548">
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#d0e2553" title="&Pi;&rho;&omicron;&sigma;&alpha;&rho;&mu;&omicron;&gamma;ή &tau;&eta;&sigmaf; έ&nu;&tau;&alpha;&sigma;&eta;&sigmaf; ή&chi;&omicron;&upsilon; &tau;&omicron;&upsilon; &eta;&chi;&epsilon;ί&omicron;&upsilon;">
      &Pi;&rho;&omicron;&sigma;&alpha;&rho;&mu;&omicron;&gamma;ή &tau;&eta;&sigmaf; έ&nu;&tau;&alpha;&sigma;&eta;&sigmaf; ή&chi;&omicron;&upsilon; &tau;&omicron;&upsilon; &eta;&chi;&epsilon;ί&omicron;&upsilon;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-using-printer-control-panel-topic.html#d0e2645" title="&Sigma;ύ&nu;&delta;&epsilon;&sigma;&eta; &sigma;&epsilon; &delta;ί&kappa;&tau;&upsilon;&omicron;">
      &Sigma;ύ&nu;&delta;&epsilon;&sigma;&eta; &sigma;&epsilon; &delta;ί&kappa;&tau;&upsilon;&omicron;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_el" title="&Rho;ύ&theta;&mu;&iota;&sigma;&eta; &sigma;&epsilon;&iota;&rho;&iota;&alpha;&kappa;ή&sigmaf; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf; (&mu;ό&nu;&omicron; &gamma;&iota;&alpha; Windows)">
      &Rho;ύ&theta;&mu;&iota;&sigma;&eta; &sigma;&epsilon;&iota;&rho;&iota;&alpha;&kappa;ή&sigmaf; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf; (&mu;ό&nu;&omicron; &gamma;&iota;&alpha; Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_el" title="&Kappa;&alpha;&theta;&alpha;&rho;&iota;&sigma;&mu;ό&sigmaf; &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
      &Kappa;&alpha;&theta;&alpha;&rho;&iota;&sigma;&mu;ό&sigmaf; &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_el" title="&Pi;&alpha;&rho;&alpha;&gamma;&gamma;&epsilon;&lambda;ί&alpha; &epsilon;&xi;&alpha;&rho;&tau;&eta;&mu;ά&tau;&omega;&nu; &kappa;&alpha;&iota; &alpha;&nu;&alpha;&lambda;&omega;&sigma;ί&mu;&omega;&nu;">
      &Pi;&alpha;&rho;&alpha;&gamma;&gamma;&epsilon;&lambda;ί&alpha; &epsilon;&xi;&alpha;&rho;&tau;&eta;&mu;ά&tau;&omega;&nu; &kappa;&alpha;&iota; &alpha;&nu;&alpha;&lambda;&omega;&sigma;ί&mu;&omega;&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-developer-unit-topic.html#d0e3211" title="&Alpha;&nu;&tau;&iota;&kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta; &epsilon;&xi;&alpha;&rho;&tau;&eta;&mu;ά&tau;&omega;&nu; &kappa;&alpha;&iota; &alpha;&nu;&alpha;&lambda;&omega;&sigma;ί&mu;&omega;&nu;">
      &Alpha;&nu;&tau;&iota;&kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta; &epsilon;&xi;&alpha;&rho;&tau;&eta;&mu;ά&tau;&omega;&nu; &kappa;&alpha;&iota; &alpha;&nu;&alpha;&lambda;&omega;&sigma;ί&mu;&omega;&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#storing-supplies_el" title="&Alpha;&pi;&omicron;&theta;ή&kappa;&epsilon;&upsilon;&sigma;&eta; &alpha;&nu;&alpha;&lambda;ώ&sigma;&iota;&mu;&omega;&nu;">
      &Alpha;&pi;&omicron;&theta;ή&kappa;&epsilon;&upsilon;&sigma;&eta; &alpha;&nu;&alpha;&lambda;ώ&sigma;&iota;&mu;&omega;&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e3681" title="&Mu;&epsilon;&tau;&alpha;&phi;&omicron;&rho;ά &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή">
      &Mu;&epsilon;&tau;&alpha;&phi;&omicron;&rho;ά &tau;&omicron;&upsilon; &epsilon;&kappa;&tau;&upsilon;&pi;&omega;&tau;ή
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e3737" title="&Epsilon;&xi;&omicron;&iota;&kappa;&omicron;&nu;ό&mu;&eta;&sigma;&eta; &epsilon;&nu;έ&rho;&gamma;&epsilon;&iota;&alpha;&sigmaf; &kappa;&alpha;&iota; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ">
      &Epsilon;&xi;&omicron;&iota;&kappa;&omicron;&nu;ό&mu;&eta;&sigma;&eta; &epsilon;&nu;έ&rho;&gamma;&epsilon;&iota;&alpha;&sigmaf; &kappa;&alpha;&iota; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e3875" title="&Alpha;&nu;&alpha;&kappa;ύ&kappa;&lambda;&omega;&sigma;&eta;">
      &Alpha;&nu;&alpha;&kappa;ύ&kappa;&lambda;&omega;&sigma;&eta;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_el" title="&Alpha;&pi;&omicron;&kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta; &epsilon;&mu;&pi;&lambda;&omicron;&kappa;ώ&nu;">
     &Alpha;&pi;&omicron;&kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta; &epsilon;&mu;&pi;&lambda;&omicron;&kappa;ώ&nu;
    </a>
   </p>
   <div id="divd0e3929">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_el" title="&Alpha;&pi;&omicron;&phi;&upsilon;&gamma;ή &epsilon;&mu;&pi;&lambda;&omicron;&kappa;ώ&nu;">
      &Alpha;&pi;&omicron;&phi;&upsilon;&gamma;ή &epsilon;&mu;&pi;&lambda;&omicron;&kappa;ώ&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_el" title="&Epsilon;&nu;&tau;&omicron;&pi;&iota;&sigma;&mu;ό&sigmaf; &theta;έ&sigma;&epsilon;&omega;&nu; &epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή&sigmaf;">
      &Epsilon;&nu;&tau;&omicron;&pi;&iota;&sigma;&mu;ό&sigmaf; &theta;έ&sigma;&epsilon;&omega;&nu; &epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-trays-topic.html#jam-in-trays_el" title="&Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&iota;&sigmaf; &theta;ή&kappa;&epsilon;&sigmaf;">
      &Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&iota;&sigmaf; &theta;ή&kappa;&epsilon;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jams-in-mpf-topic.html#jams-in-mpf_el" title="&Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&omicron;&nu; &tau;&rho;&omicron;&phi;&omicron;&delta;ό&tau;&eta; &delta;&iota;&alpha;&phi;&omicron;&rho;&epsilon;&tau;&iota;&kappa;ώ&nu; &mu;&epsilon;&gamma;&epsilon;&theta;ώ&nu;">
      &Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&omicron;&nu; &tau;&rho;&omicron;&phi;&omicron;&delta;ό&tau;&eta; &delta;&iota;&alpha;&phi;&omicron;&rho;&epsilon;&tau;&iota;&kappa;ώ&nu; &mu;&epsilon;&gamma;&epsilon;&theta;ώ&nu;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-standard-bin-topic.html#jam-in-standard-bin_el" title="&Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&omicron;&nu; &beta;&alpha;&sigma;&iota;&kappa;ό &delta;ί&sigma;&kappa;&omicron;">
      &Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&omicron;&nu; &beta;&alpha;&sigma;&iota;&kappa;ό &delta;ί&sigma;&kappa;&omicron;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-door-b-topic.html#jam-in-door-b_el" title="&Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&eta; &theta;ύ&rho;&alpha; B">
      &Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&eta; &theta;ύ&rho;&alpha; B
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-finisher-bin-topic.html#jam-in-finisher-bin_el" title="&Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&eta;&nu; &upsilon;&pi;&omicron;&delta;&omicron;&chi;ή &mu;&omicron;&nu;ά&delta;&alpha;&sigmaf; &phi;&iota;&nu;&iota;&rho;ί&sigma;&mu;&alpha;&tau;&omicron;&sigmaf;">
      &Epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &chi;&alpha;&rho;&tau;&iota;&omicron;ύ &sigma;&tau;&eta;&nu; &upsilon;&pi;&omicron;&delta;&omicron;&chi;ή &mu;&omicron;&nu;ά&delta;&alpha;&sigmaf; &phi;&iota;&nu;&iota;&rho;ί&sigma;&mu;&alpha;&tau;&omicron;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-door-g-topic.html#staple-jam-door-g_el" title="&epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &sigma;&tau;&eta; &sigma;&upsilon;&rho;&rho;&alpha;&phi;ή &sigma;&tau;&eta; &theta;ύ&rho;&alpha; G">
      &epsilon;&mu;&pi;&lambda;&omicron;&kappa;ή &sigma;&tau;&eta; &sigma;&upsilon;&rho;&rho;&alpha;&phi;ή &sigma;&tau;&eta; &theta;ύ&rho;&alpha; G
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_el" title="&Alpha;&nu;&tau;&iota;&mu;&epsilon;&tau;ώ&pi;&iota;&sigma;&eta; &pi;&rho;&omicron;&beta;&lambda;&eta;&mu;ά&tau;&omega;&nu;">
     &Alpha;&nu;&tau;&iota;&mu;&epsilon;&tau;ώ&pi;&iota;&sigma;&eta; &pi;&rho;&omicron;&beta;&lambda;&eta;&mu;ά&tau;&omega;&nu;
    </a>
   </p>
   <div id="divd0e4273">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e4276" title="&Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &sigma;ύ&nu;&delta;&epsilon;&sigma;&eta;&sigmaf; &delta;&iota;&kappa;&tau;ύ&omicron;&upsilon;">
      &Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &sigma;ύ&nu;&delta;&epsilon;&sigma;&eta;&sigmaf; &delta;&iota;&kappa;&tau;ύ&omicron;&upsilon;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e4491" title="&Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &pi;&rho;ό&sigma;&theta;&epsilon;&tau;&omega;&nu; &epsilon;&xi;&alpha;&rho;&tau;&eta;&mu;ά&tau;&omega;&nu; &upsilon;&lambda;&iota;&kappa;&omicron;ύ">
      &Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &pi;&rho;ό&sigma;&theta;&epsilon;&tau;&omega;&nu; &epsilon;&xi;&alpha;&rho;&tau;&eta;&mu;ά&tau;&omega;&nu; &upsilon;&lambda;&iota;&kappa;&omicron;ύ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e4763" title="&Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &mu;&epsilon; &alpha;&nu;&alpha;&lambda;ώ&sigma;&iota;&mu;&alpha;">
      &Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &mu;&epsilon; &alpha;&nu;&alpha;&lambda;ώ&sigma;&iota;&mu;&alpha;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_el" title="&Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &tau;&rho;&omicron;&phi;&omicron;&delta;&omicron;&sigma;ί&alpha;&sigmaf; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ">
      &Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &tau;&rho;&omicron;&phi;&omicron;&delta;&omicron;&sigma;ί&alpha;&sigmaf; &chi;&alpha;&rho;&tau;&iota;&omicron;ύ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_el" title="&Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;">
      &Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#d0e7305" title="&Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &pi;&omicron;&iota;ό&tau;&eta;&tau;&alpha;&sigmaf; έ&gamma;&chi;&rho;&omega;&mu;&eta;&sigmaf; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;">
      &Pi;&rho;&omicron;&beta;&lambda;ή&mu;&alpha;&tau;&alpha; &pi;&omicron;&iota;ό&tau;&eta;&tau;&alpha;&sigmaf; έ&gamma;&chi;&rho;&omega;&mu;&eta;&sigmaf; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_el" title="&Epsilon;&pi;&iota;&kappa;&omicron;&iota;&nu;&omega;&nu;ί&alpha; &mu;&epsilon; &tau;&eta;&nu; &Upsilon;&pi;&omicron;&sigma;&tau;ή&rho;&iota;&xi;&eta; &pi;&epsilon;&lambda;&alpha;&tau;ώ&nu;">
      &Epsilon;&pi;&iota;&kappa;&omicron;&iota;&nu;&omega;&nu;ί&alpha; &mu;&epsilon; &tau;&eta;&nu; &Upsilon;&pi;&omicron;&sigma;&tau;ή&rho;&iota;&xi;&eta; &pi;&epsilon;&lambda;&alpha;&tau;ώ&nu;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_el" title="&Alpha;&nu;&alpha;&beta;ά&theta;&mu;&iota;&sigma;&eta; &kappa;&alpha;&iota; &mu;&epsilon;&tau;&epsilon;&gamma;&kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta;">
     &Alpha;&nu;&alpha;&beta;ά&theta;&mu;&iota;&sigma;&eta; &kappa;&alpha;&iota; &mu;&epsilon;&tau;&epsilon;&gamma;&kappa;&alpha;&tau;ά&sigma;&tau;&alpha;&sigma;&eta;
    </a>
   </p>
   <div id="divd0e7540">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e7543" title="&Upsilon;&lambda;&iota;&kappa;ό">
      &Upsilon;&lambda;&iota;&kappa;ό
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7869" title="&Lambda;&omicron;&gamma;&iota;&sigma;&mu;&iota;&kappa;ό">
      &Lambda;&omicron;&gamma;&iota;&sigma;&mu;&iota;&kappa;ό
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e7945" title="&Upsilon;&lambda;&iota;&kappa;&omicron;&lambda;&omicron;&gamma;&iota;&sigma;&mu;&iota;&kappa;ό">
      &Upsilon;&lambda;&iota;&kappa;&omicron;&lambda;&omicron;&gamma;&iota;&sigma;&mu;&iota;&kappa;ό
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_el" title="&Sigma;&eta;&mu;&epsilon;&iota;ώ&sigma;&epsilon;&iota;&sigmaf;">
     &Sigma;&eta;&mu;&epsilon;&iota;ώ&sigma;&epsilon;&iota;&sigmaf;
    </a>
   </p>
   <div id="divd0e8014">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8017" title="&Pi;&lambda;&eta;&rho;&omicron;&phi;&omicron;&rho;ί&epsilon;&sigmaf; &pi;&rho;&omicron;ϊό&nu;&tau;&omicron;&sigmaf;">
      &Pi;&lambda;&eta;&rho;&omicron;&phi;&omicron;&rho;ί&epsilon;&sigmaf; &pi;&rho;&omicron;ϊό&nu;&tau;&omicron;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8034" title="&Sigma;&eta;&mu;&epsilon;ί&omega;&sigma;&eta; &gamma;&iota;&alpha; &tau;&eta;&nu; έ&kappa;&delta;&omicron;&sigma;&eta;">
      &Sigma;&eta;&mu;&epsilon;ί&omega;&sigma;&eta; &gamma;&iota;&alpha; &tau;&eta;&nu; έ&kappa;&delta;&omicron;&sigma;&eta;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_el" title="&Epsilon;&mu;&pi;&omicron;&rho;&iota;&kappa;ά &sigma;ή&mu;&alpha;&tau;&alpha;">
      &Epsilon;&mu;&pi;&omicron;&rho;&iota;&kappa;ά &sigma;ή&mu;&alpha;&tau;&alpha;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_el" title="&Sigma;&eta;&mu;&epsilon;&iota;ώ&sigma;&epsilon;&iota;&sigmaf; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&eta; &chi;&omicron;&rho;ή&gamma;&eta;&sigma;&eta; &alpha;&delta;&epsilon;&iota;ώ&nu; &chi;&rho;ή&sigma;&eta;&sigmaf;">
      &Sigma;&eta;&mu;&epsilon;&iota;ώ&sigma;&epsilon;&iota;&sigmaf; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&eta; &chi;&omicron;&rho;ή&gamma;&eta;&sigma;&eta; &alpha;&delta;&epsilon;&iota;ώ&nu; &chi;&rho;ή&sigma;&eta;&sigmaf;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_el" title="&Epsilon;&pi;ί&pi;&epsilon;&delta;&alpha; &epsilon;&kappa;&pi;&omicron;&mu;&pi;ή&sigmaf; ή&chi;&omicron;&upsilon;">
      &Epsilon;&pi;ί&pi;&epsilon;&delta;&alpha; &epsilon;&kappa;&pi;&omicron;&mu;&pi;ή&sigmaf; ή&chi;&omicron;&upsilon;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8122" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8149" title="&Epsilon;&pi;&alpha;&nu;&alpha;&phi;&omicron;&rho;&tau;&iota;&zeta;ό&mu;&epsilon;&nu;&eta; &mu;&pi;&alpha;&tau;&alpha;&rho;ί&alpha; &iota;ό&nu;&tau;&omega;&nu; &lambda;&iota;&theta;ί&omicron;&upsilon;">
      &Epsilon;&pi;&alpha;&nu;&alpha;&phi;&omicron;&rho;&tau;&iota;&zeta;ό&mu;&epsilon;&nu;&eta; &mu;&pi;&alpha;&tau;&alpha;&rho;ί&alpha; &iota;ό&nu;&tau;&omega;&nu; &lambda;&iota;&theta;ί&omicron;&upsilon;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_el" title="&Kappa;&alpha;&nu;&omicron;&nu;&iota;&sigma;&mu;ό&sigmaf; (&Epsilon;&Epsilon;) 2023/1542">
      &Kappa;&alpha;&nu;&omicron;&nu;&iota;&sigma;&mu;ό&sigmaf; (&Epsilon;&Epsilon;) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_el" title="&Epsilon;&pi;&iota;&sigma;&tau;&rho;&omicron;&phi;ή &kappa;&alpha;&sigma;&epsilon;&tau;ώ&nu; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf; Lexmark &gamma;&iota;&alpha; &epsilon;&pi;&alpha;&nu;&alpha;&chi;&rho;&eta;&sigma;&iota;&mu;&omicron;&pi;&omicron;ί&eta;&sigma;&eta; ή &alpha;&nu;&alpha;&kappa;ύ&kappa;&lambda;&omega;&sigma;&eta;">
      &Epsilon;&pi;&iota;&sigma;&tau;&rho;&omicron;&phi;ή &kappa;&alpha;&sigma;&epsilon;&tau;ώ&nu; &epsilon;&kappa;&tau;ύ&pi;&omega;&sigma;&eta;&sigmaf; Lexmark &gamma;&iota;&alpha; &epsilon;&pi;&alpha;&nu;&alpha;&chi;&rho;&eta;&sigma;&iota;&mu;&omicron;&pi;&omicron;ί&eta;&sigma;&eta; ή &alpha;&nu;&alpha;&kappa;ύ&kappa;&lambda;&omega;&sigma;&eta;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_el" title="&Sigma;&eta;&mu;&epsilon;ί&omega;&sigma;&eta; &gamma;&iota;&alpha; &tau;&eta;&nu; &epsilon;&upsilon;&alpha;&iota;&sigma;&theta;&eta;&sigma;ί&alpha; &sigma;&tau;&omicron;&nu; &sigma;&tau;&alpha;&tau;&iota;&kappa;ό &eta;&lambda;&epsilon;&kappa;&tau;&rho;&iota;&sigma;&mu;ό">
      &Sigma;&eta;&mu;&epsilon;ί&omega;&sigma;&eta; &gamma;&iota;&alpha; &tau;&eta;&nu; &epsilon;&upsilon;&alpha;&iota;&sigma;&theta;&eta;&sigma;ί&alpha; &sigma;&tau;&omicron;&nu; &sigma;&tau;&alpha;&tau;&iota;&kappa;ό &eta;&lambda;&epsilon;&kappa;&tau;&rho;&iota;&sigma;&mu;ό
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_el" title="&Pi;&lambda;&eta;&rho;&omicron;&phi;&omicron;&rho;ί&epsilon;&sigmaf; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&eta; &theta;&epsilon;&rho;&mu;&omicron;&kappa;&rho;&alpha;&sigma;ί&alpha;">
      &Pi;&lambda;&eta;&rho;&omicron;&phi;&omicron;&rho;ί&epsilon;&sigmaf; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&eta; &theta;&epsilon;&rho;&mu;&omicron;&kappa;&rho;&alpha;&sigma;ί&alpha;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_el" title="&Sigma;&eta;&mu;&epsilon;ί&omega;&sigma;&eta; laser">
      &Sigma;&eta;&mu;&epsilon;ί&omega;&sigma;&eta; laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-advisory-label_el" title="&Epsilon;&tau;&iota;&kappa;έ&tau;&alpha; &sigma;ύ&sigma;&tau;&alpha;&sigma;&eta;&sigmaf; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&omicron; laser">
      &Epsilon;&tau;&iota;&kappa;έ&tau;&alpha; &sigma;ύ&sigma;&tau;&alpha;&sigma;&eta;&sigmaf; &sigma;&chi;&epsilon;&tau;&iota;&kappa;ά &mu;&epsilon; &tau;&omicron; laser
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue